import { QuantitySelectorComponent } from '@theme/component-quantity-selector';

/**
 * A custom element that allows the user to select a quantity in the cart.
 * Extends QuantitySelectorComponent but uses absolute max limits instead of effective max.
 * Semantics: "What should the total quantity BE in the cart" vs "How many to ADD to cart"
 *
 * @extends {QuantitySelectorComponent}
 */
class CartQuantitySelectorComponent extends QuantitySelectorComponent {
  choosePack(event) {
    const button = event.target.closest('[data-pack-quantity]');
    if (!button || !this.contains(button)) return;
    const next = Number(button.dataset.packQuantity);
    const { min, max, value } = this.getCurrentValues();
    if (next !== min && next !== max || next === value) return;
    this.refs.quantityInput.value = String(next);
    this.onQuantityChange();
    this.updateButtonStates();
  }

  // An old invalid quantity must move to a supported pack count on the first click.
  updateQuantity(direction) {
    if (this.dataset.freshPack !== 'true') return super.updateQuantity(direction);
    const { min, max, value } = this.getCurrentValues();
    const next = direction > 0 ? (value < min ? min : max) : (value > min ? (value > max ? max : min) : min);
    this.refs.quantityInput.value = String(next);
    this.onQuantityChange();
    this.updateButtonStates();
  }

  /**
   * Gets the effective maximum value for cart quantity selector
   * Cart page: uses absolute max (how much can be in cart total)
   * @returns {number | null} The effective max, or null if no max
   */
  getEffectiveMax() {
    const { max } = this.getCurrentValues();
    return max; // Cart uses absolute max, not max minus cart quantity
  }

  /**
   * Updates button states based on current value and limits
   * Cart buttons are always managed client-side, never server-disabled
   */
  updateButtonStates() {
    const { minusButton, plusButton } = this.refs;
    const { min, value } = this.getCurrentValues();
    const effectiveMax = this.getEffectiveMax();

    for (const choice of this.querySelectorAll('[data-pack-quantity]')) {
      choice.setAttribute('aria-pressed', String(Number(choice.dataset.packQuantity) === value));
    }
    // Cart buttons are always dynamically managed
    minusButton.disabled = value <= min;
    plusButton.disabled = effectiveMax !== null && value >= effectiveMax;
  }
}

if (!customElements.get('cart-quantity-selector-component')) {
  customElements.define('cart-quantity-selector-component', CartQuantitySelectorComponent);
}
